import {Injectable} from '@angular/core';

const repositoryKeyStore = 'ReportRepository';

@Injectable()
export class ReportSelectionService {
    constructor() {}

    selection: any;

  static selectFirstReport() {
    const repository: any = JSON.parse(sessionStorage.getItem(repositoryKeyStore));
    return repository[0].reports[0];
  }

    public setReportSelection(report) {
        this.selection = report;
    }

    public getReportSelection() {
        if (!this.selection) {
            this.selection = ReportSelectionService.selectFirstReport();
        }
        return this.selection;
    }

    public clearSelection() {
        this.selection = undefined;
    }
}
